import { compose } from 'recompose';

import CaseStudyCreate from './CaseStudyCreate';

const enhance = compose();

export default enhance(CaseStudyCreate);
